export function getTokenFromLocalStorage() {
    return localStorage.getItem("token");
}
